import {get} from 'aws-amplify/api';

import {Command, type GetMethod} from '../../Command';
import type {GetOnePublicDraftResponse} from '../../../dto/draft/GetOnePublicDraftResponse';

export class GetOnePublicDraftCommand extends Command<GetMethod, GetOnePublicDraftResponse> {
  constructor(id: string) {
    super(get, {
      path: `/draft/${id}/public`,
      options: {
        withCredentials: false,
      },
    });
  }

  async deserialize(output: ReturnType<typeof get>): Promise<GetOnePublicDraftResponse> {
    const {body} = await output.response;
    return await (body.json() as unknown as Promise<GetOnePublicDraftResponse>);
  }
}
